import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig } from '../../../config/config'; // Importing development configuration

export default class transfersView extends JetView {
    // Defining the transfersView class extending JetView
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration
        const theme = this.app.config.theme; // Theme configuration
        const vthis = this; // Reference to the current instance

        /**
         * Changes the color of buttons based on the selected option.
         * @param {number} option - The selected option (0 or 1).
         */
        function changeColor(option) {
            if (option == 0) {
                webix.html.removeCss($$('button1').$view, 'black'); // Remove black color from button1
                webix.html.addCss($$('button1').$view, 'green'); // Add green color to button1
                webix.html.removeCss($$('button2').$view, 'green'); // Remove green color from button2
                webix.html.addCss($$('button2').$view, 'black'); // Add black color to button2
            } else {
                webix.html.removeCss($$('button1').$view, 'green'); // Remove green color from button1
                webix.html.addCss($$('button1').$view, 'black'); // Add black color to button1
                webix.html.removeCss($$('button2').$view, 'black'); // Remove black color from button2
                webix.html.addCss($$('button2').$view, 'green'); // Add green color to button2
            }
        }

        const left = {
            // Left section configuration
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'label',
                            align: 'center',
                            label: _('¿ Qué desea realizar ?'), // Label text
                            minWidth: 200,
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'button',
                            value: _('Retracción a Saldo Recargas'), // Button text
                            id: 'button1', // Button ID
                            on: {
                                onItemClick: function (id) {
                                    // Click event for button1
                                    changeColor(0); // Change color for button1
                                    $$('formPagoPremio').show(); // Show payment form
                                    vthis.app.callEvent('transfertSelected', [
                                        // Trigger event for transfer selection
                                        { id: '0' },
                                    ]);
                                    $$('a5').scrollTo(0, 1000); // Scroll to a specific position
                                },
                            },
                        },
                        {
                            view: 'button',
                            value: _('Retracción a Saldo Juego'), // Button text
                            id: 'button2', // Button ID
                            on: {
                                onItemClick: function (id) {
                                    // Click event for button2
                                    changeColor(1); // Change color for button2
                                    $$('formPagoPremio').show(); // Show payment form
                                    vthis.app.callEvent('transfertSelected', [
                                        // Trigger event for transfer selection
                                        { id: '1' },
                                    ]);
                                    $$('a5').scrollTo(0, 1000); // Scroll to a specific position
                                },
                            },
                        },
                    ],
                },
            ],
        };

        const upper_section = {
            // Upper section configuration
            css: 'father-container',
            height: screen == 'small' ? 150 : 0, // Height based on screen size
            width: 0,
            cols: [left], // Include left section
        };

        return {
            // Return the main configuration object
            view: 'form',
            id: 'formPagoPremio1', // Form ID
            rows: [upper_section], // Include upper section
            rules: {
                // Validation rules for form fields
                Amount: function (value) {
                    return value >= 0; // Amount must be non-negative
                },
                AmountConfirm: function (value) {
                    return value >= 0; // Confirmed amount must be non-negative
                },
            },
        };
    }

    /**
     * Initializes the view and sets up any necessary event listeners.
     * @param {Object} form - The form instance.
     */
    init(form) {
        $$('formPagoPremio1').hide(); // Hide the payment form initially
        webix.ready(function () {
            // Execute when Webix is ready
            if (screen.width < 500) {
                // Check for small screen size
            }
        });
    }
}

// FILE DOCUMENTED
